import { createAsyncThunk } from "@reduxjs/toolkit";

import identity from "lodash/identity";
import pickBy from "lodash/pickBy";

import { filterData } from "@/lib";
import { getProjects } from "@/models";
import { AppState } from "@/redux/store/store";
import { fetchAuthToken } from "@/helpers/fetch-auth-token";

export const fetchProjects = createAsyncThunk(
  "projects/fetchProjects",
  async (params: Partial<{ config?: any }>, { rejectWithValue, getState }) => {
    const { config } = params;
    const { projectFinder, adapter } = getState() as AppState;

    const { baseUrl } = adapter.adapter;

    const {
      maxRecords,
      filterByName,
      filterByState,
      filterByTag,
      filterByDate
    } = projectFinder.queryFilter;
    const { token } = fetchAuthToken(getState());

    try {
      const response = await getProjects(
        token,
        baseUrl,
        {
          filterable: true,
          per_page: Number(maxRecords)
            ? Math.min(Number(maxRecords), 600)
            : 600,
          page: 1,
          filters: pickBy(
            {
              visibility_mode: "public",
              sort: { published_at: "desc" },
              search: filterByName,
              state: filterByState,
              tags: filterByTag ? [filterByTag] : null
            },
            identity
          )
        },
        config
      );

      /*
       * Unfortunately, our API doesn't support queries on publishedAt
       * so, after fetching data from API we need to create a subset of it
       * hopefully our API would support more complex queries
       */

      const projects: any = filterData(response, {
        publishedAt: filterByDate
      });
      return projects;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
